const styles = (theme) => ({
	container: {
		width: "100%",
		backgroundColor: theme.palette.background.paper,
		borderRadius: "16px",
		padding: "16px",
		marginTop: "16px",
		display: "flex",
		flexDirection: "column",
		gap: 1,
	},
	titulo: {
		color: theme.palette.text.primary,
		fontWeight: 600,
	},
	resumoLinha: {
		display: "flex",
		alignItems: "center",
		flexWrap: "wrap",
		gap: 2,
	},
	resumoTexto: {
		color: theme.palette.text.secondary,
	},
	paper: {
		width: "100%",
		backgroundColor: theme.palette.background.paper,
		borderRadius: "16px",
		overflow: "hidden",
	},
	chip: {
		fontWeight: 600,
		height: "20px",
	},
	// Linha do grid tem 28px fixos e a celula 4px de padding em cima e embaixo, sobram 20px: 18px de linha + 2px de borda
	botaoAcao: {
		py: 0,
		lineHeight: "18px",
		whiteSpace: "nowrap",
	},
});

export default styles;
